import { IAttributeFilterState, IFilter, IRootState, IFilterGrouping } from '@/store/types/IRootState';

export enum FilterType {
  Descricao = 'Descricao',
  Atributos = 'Atributos',
  Codigo = 'Codigo',
  Codigo2 = 'Codigo2',
  Empresas = 'Empresas',
  Categorias = 'Categorias',
  Tipo = 'CodTipo',
}

const filterMutations = {
  checkFilter(state: IRootState, params: { name: string; filterValue: string}) {
    state.currentMaxItems = state.defaultMaxItems;
    const attrFilter = state.attributeFilters
    .filter((attributeFilter: IAttributeFilterState) => attributeFilter.name === params.name);

    if (attrFilter.length > 0) {
          const filter = attrFilter[0].filters.filter((currentFilter: IFilter) => currentFilter.value === params.filterValue)[0];
          filter.checked = !filter.checked;
    } else {
        const manufacturerFilter = state.manufacturerFilters.filters
          .filter((currentFilter: IFilter) => currentFilter.name === params.name)[0];
        if (manufacturerFilter) { manufacturerFilter.checked = !manufacturerFilter.checked; }

        const companyFilter = state.companyFilters.filters
          .filter((currentFilter: IFilter) => currentFilter.value === params.filterValue)[0];
        if (companyFilter) { companyFilter.checked = !companyFilter.checked; }

        const itemTypeFilters = state.itemTypeFilters.filters
          .filter((currentFilter: IFilter) => currentFilter.value === params.filterValue)[0];
        if (itemTypeFilters) { itemTypeFilters.checked = !itemTypeFilters.checked; }

        const categoryFilters = state.categoryFilters.groupings
          .flatMap(g => g.filters);
        const checkedParents = categoryFilters
          .filter((currentFilter: IFilter) => currentFilter.value === params.filterValue)[0];
        if (checkedParents) { checkedParents.checked = !checkedParents.checked;
        } else {
          const checkedSubfilters = categoryFilters
            .flatMap(f => f.subfilters || [])
            .filter((currentFilter: IFilter) => currentFilter.value === params.filterValue)[0];
          if (checkedSubfilters) { checkedSubfilters.checked = !checkedSubfilters.checked; }
        }
    }
  },
  uncheckCheckedFilters(state: IRootState) {
    state.currentMaxItems = state.defaultMaxItems;
    const checkedManufacturerFilters = state.manufacturerFilters.filters.filter(
      (currentFilter: IFilter) => currentFilter.checked === true)
      .reduce(
          (previousValues: any, current: any) => previousValues.concat(current),
          [],
      );
    checkedManufacturerFilters.forEach((checkedManufacturerFilter: IFilter) => {
      checkedManufacturerFilter.checked = false;
      });

    const checkedCompanyFilters = state.companyFilters.filters.filter(
        (currentFilter: IFilter) => currentFilter.checked === true)
        .reduce(
            (previousValues: any, current: any) => previousValues.concat(current),
            [],
        );
    checkedCompanyFilters.forEach((checkedCompanyFilter: IFilter) => {
      checkedCompanyFilter.checked = false;
        });

    const checkedAttributeFilters = state.attributeFilters
      .map((attributeFilter: IAttributeFilterState) =>
        attributeFilter.filters.filter(
          (currentFilter: any) => currentFilter.checked === true,
        ),
      )
      .reduce(
        (previousValues: any, current: any) => previousValues.concat(current),
        [],
      );
    checkedAttributeFilters.forEach((checkedManufacturerFilter: IFilter) => {
        checkedManufacturerFilter.checked = false;
        });

    const checkedItemTypeFilters = state.itemTypeFilters.filters.filter(
      (currentFilter: IFilter) => currentFilter.checked === true)
      .reduce(
          (previousValues: any, current: any) => previousValues.concat(current),
          [],
      );
    checkedItemTypeFilters.forEach((checkedItemTypeFilter: IFilter) => {
      checkedItemTypeFilter.checked = false;
    });

    const categoryFilters = state.categoryFilters.groupings.flatMap(g => g.filters);
    const checkedParents = categoryFilters.filter((currentFilter: IFilter) => currentFilter.checked);
    const checkedSubfilters = categoryFilters
      .flatMap(f => f.subfilters || [])
      .filter((currentFilter: IFilter) => currentFilter.checked);

    checkedParents.concat(checkedSubfilters).forEach((checkedItemTypeFilter: IFilter) => {
      checkedItemTypeFilter.checked = false;
    });
  },
};
export default filterMutations;
